module.exports = __webpack_public_path__ + "static/media/imagem30.9b85e031.jpeg";